import { TitleCasePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, ControlContainer, FormControlDirective } from '@angular/forms';
import { ControlSettings } from '../../ControlSettings';

@Component({
  selector: 'url-text-input-ctrl',
  templateUrl: './url-text-input.component.html',
  styleUrls: ['./url-text-input.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: UrlTextInputComponent,
    multi: true
  }]
})
export class UrlTextInputComponent implements ControlValueAccessor  {

  constructor(protected controlContainer: ControlContainer) {

  }

  @ViewChild(FormControlDirective, { static: true })
  formControlDirective: FormControlDirective;
  

  @Input() public formControlName: string;
  @Input() caption: string;
  @Input() windowName = '_blank';
 
  @Input() settings:ControlSettings = {};
  defaultSettings:ControlSettings = {uppercase:false, fxFill:false};
  titleCasePipe: TitleCasePipe = new TitleCasePipe();

  ngOnInit(): void {
     Object.assign(this.defaultSettings,this.settings);
    this.settings = this.defaultSettings;

  }

  navigateToUrl(){
    
    let url = this.control.value;
    if(!url){
      return false;
    }

    url = url.match(/^http[s]?:\/\//) ? url : 'https://' + url;
    window.open(url,this.windowName);
  }

  onChange(value: string) {
    if (this.settings.uppercase) {
      value = value.toUpperCase();
    }

    if (this.settings.firstLetterUpper) {
      value = this.titleCasePipe.transform(value);
    }

    value = value.trim();

    this.control.setValue(value);
  }

  public get control() {
    return this.controlContainer.control.get(this.formControlName);
  }


  registerOnTouched(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective.valueAccessor.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective.valueAccessor.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective.valueAccessor.setDisabledState(isDisabled);
  }

}
